import React from 'react'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'

const Contacts = () => {
    return (
        <div className="contacts">
            <ul>
            
                <li>
                    <AccountCircleIcon />
                    <span>Mitesh Chaudhari</span>
                </li>
                <li>
                    <AccountCircleIcon />
                    <span>Covid-19 Information Center</span>
                </li>
                <li>
                    <AccountCircleIcon />
                    <span>Friends</span>
                </li>
                <li>
                    <AccountCircleIcon />
                    <span>Groups</span>
                </li>
                <li>
                    <AccountCircleIcon />
                    <span>Marketplace</span>
                </li>
                <li>
                    <AccountCircleIcon />
                    <span>Watch</span>
                </li>
                <li>
                    <AccountCircleIcon />
                    <span>Events</span>
                </li>
                <li>
                    <AccountCircleIcon />
                    <span>Memory</span>
                </li>
                <li>
                    <AccountCircleIcon />
                    <span>Watch</span>
                </li>
                <li>
                    <AccountCircleIcon />
                    <span>Events</span>
                </li>
                <li>
                    <AccountCircleIcon />
                    <span>Memory</span>
                </li>
                <li>
                    <AccountCircleIcon />
                    <span>Watch</span>
                </li>
                <li>
                    <AccountCircleIcon />
                    <span>Events</span>
                </li>
                <li>
                    <AccountCircleIcon />
                    <span>Memory</span>
                </li>
                {/* <li>
                    <span></span>
                </li> */}
            </ul>
            
        </div>
    )
}

export default Contacts
